
const config = {
  loginPage: '/login',
  appId: 'supnr', //配置APPID
  server: "/",
  serverBlock: "https://admin-mb1.sup.services/admin/dpms/server/dataModel/queryTree", //正式域名


}

const apiList = {

  //系统模块
  sys: {
    admin_login: 'loginJson',
    admin_login_check: "validate",
    search_user: "mgr/search",
    anonymousUserSwitchSave: "admin/user/anonymousUserSwitch/save",
    anonymousUserSwitchGet: "admin/user/anonymousUserSwitch/get"

  },

}

export default {
  config,
  apiList
}